import { call, options, params } from './helpers';

export const getTickets = (payload) => call(`/beta/tickets${params(payload)}`);

export const getTicketsWithStats = (payload) =>
	call(`/beta/tickets/stats${params(payload)}`);

export const addTicket = (payload) =>
	call(`/beta/tickets`, options(payload, 'POST'));

export const addTicketPublic = (payload) =>
	call(`/beta/tickets/create-public`, options(payload, 'POST'));

export const getTicket = ({ id }) => call(`/beta/tickets/${id}`);

export const commentOnTicket = ({ id, ...payload }) =>
	call(`/beta/tickets/${id}/comment`, options(payload, 'POST'));

export const closeTicket = ({ id }) =>
	call(`/beta/tickets/${id}/close`, options(null, 'PUT'));

export const openTicket = ({ id }) =>
	call(`/beta/tickets/${id}/open`, options(null, 'PUT'));

export const updateTicket = ({ id, ...payload }) =>
	call(`/beta/tickets/${id}`, options(payload, 'PUT'));

export const deleteTicket = ({ id }) =>
	call(`/beta/tickets/${id}`, options(null, 'DELETE'));
